import React from "react";
import { SVG, IconProps } from "../SVG";

const DEFAULT_SIZE = 24;
export const CaretLeft = ({ size = DEFAULT_SIZE, color = "#212121", ...props }: IconProps) => (
    <SVG
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        size={size}
        color={color}
        {...props}
    >
        <path
            fill="currentColor"
            d="M15 17.898c0 1.074-1.265 1.648-2.073.94l-6.31-5.521a1.75 1.75 0 0 1 0-2.634l6.31-5.522c.808-.707 2.073-.133 2.073.94v11.797Z"
        />
    </SVG>
);
CaretLeft.displayName = "CaretLeft";
